export default __webpack_public_path__ + "static/media/data.6c856405.svg";